var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-end"},[_c('b-button',{staticClass:"btn-sm btn-sm-block",attrs:{"variant":"primary","title":_vm.$can('create', _vm.modulo)
      ? ("Crear " + _vm.texto) : _vm.moduloTitle,"disabled":!_vm.$can('create', _vm.modulo)},on:{"click":function($event){_vm.$can('create', _vm.modulo)
      ? _vm.$emit('processAdd')
      : ''}}},[_c('span',{staticClass:"text-nowrap"},[_vm._v("Crear "+_vm._s(_vm.texto))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }